import { getSeecommerceAppHelper } from "@warda/library-ui/contexts/AppHelperContext";
import { BASE_URL } from "./keys";
// https://wardafactory.atlassian.net/browse/SEECOMM-7901
const appHelper = getSeecommerceAppHelper(BASE_URL);
export default appHelper;
